<template>
    <div class="content">
        <p>
            <span>
                名称：
            </span><span>
                {{ object.name }}
            </span>
        </p>
        <p class="flex">
            <span>
                简介：
            </span>
            <span class="text_ellipsis_2">
                {{ object.intro }}

            </span>
        </p>
        <p>
            <span>
                所属单位:
            </span>
            <span>
                {{ object.enterprise_name }}
            </span>
        </p>
        <p>
            <span>
                创建时间：
            </span>
            <span>
                {{ object.utime_str }}
            </span>
        </p>
        <div class="data">
            <p>
                <span>
                    价格：
                </span>
                <span class="color_red">
                    {{ object.price }}元
                </span>
            </p>
            <p>
                <span>
                    AI学分：
                </span>
                <span class="color_rgb_19_179_231">
                    {{ object.credits }}分
                </span>
            </p>
        </div>
        <div class="ico topIco" :style="{
            'background-image': `url(${getBgc1('1')})` 
        }"></div>
        <div class="ico bottomIco" :style="{
            'background-image':`url(${getBgc2(object.audit_state)})` 
        }">

        </div>
    </div>
</template>

<script>
export default {
    props: {
        object: {
            type: Object,
            default: () => { }
        },
        // index: {
        //     type: Number,
        //     default: () => {}
        // }
    },
    computed: {
        getBgc1() {
            return (state) => {
                switch (state) {
                    case '1':
                        return  require('@/assets/images/manage/course/lock.jpg')
                        break;
                    case '2':

                        break;
                    case '3':

                        break;
                    default:
                        break;
                }
            }
        },
        getBgc2() {
            return (state) => {
                switch (state) {
                    
                    case '1':
                        return  require('@/assets/images/manage/course/cr_check_waitpass.png')
                        break;
                    case '2':
                    return  require('@/assets/images/manage/course/cr_check_pass.png')
                        break;
                    case '3':
                    return  require('@/assets/images/manage/course/cr_check_nopass.png')
                        break;
                    default:
                        break;
                }
            }
        }
    }
}
</script>


<style lang="less" scoped>
.content {
    position: relative;
    width: 300px;
    height: 130px;
    line-height: 22px;

    p.flex {
        display: flex;

        span:nth-child(2) {
            flex: 1;
            min-width: 0;

        }
    }

    div.data {
        display: flex;
        width: 200px;

        p {
            flex: 1;
            min-width: 0;

        }
    }

    .ico {
        position: absolute;
        z-index: -1;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .topIco {
        right: 0px;
        top: 0px;
        width: 20px;
        height: 20px;
        // background: url('~@/assets/device_alerm_icon.png') center center / 100% 100%;
        // background-size: 100% 100%;
        background-position: top right;
    }

    .bottomIco {
        right: 0px;
        bottom: 0px;
        width: 60px;
        height: 60px;
        // background: url('~@/assets/device_alerm_icon.png') center center / 100% 100%;
        // background-size: 100% 100%;
        background-position: bottom right;

    }
}

.color_rgb_19_179_231 {
    color: rgb(19, 179, 231);
}</style>>

